/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SubmittedJob } from './SubmittedJob';
import {TransientCalculationPoint} from "./TransientCalculationPoint";
/**
 * Drive Cycle S3.
 */
export type DriveCycleS3 = {
    item_type?: DriveCycleS3.item_type;
    name?: string;
    submitted_job: SubmittedJob;
    points?: Array<TransientCalculationPoint>; // TODO: Adding manually to compile GetDriveCycleDataAction which uses readDriveCyclesItemIdGet()
};
export namespace DriveCycleS3 {
    export enum item_type {
        DRIVE_CYCLE = 'drive_cycle',
    }
}

